exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".li-info-availability[data-v-6b9a45b8]{list-style-type:\"*\";margin-left:8px;color:#888!important}.availability-link[data-v-6b9a45b8]{color:#2e86ab}", "", {"version":3,"sources":["/app/src/components/availability/result/inquiry/ResultTransfer.vue"],"names":[],"mappings":"AACA,uCACE,oBAAyB,AACzB,gBAAiB,AACjB,oBAAuB,CACxB,AACD,oCACE,aAAe,CAChB","file":"ResultTransfer.vue","sourcesContent":["\n.li-info-availability[data-v-6b9a45b8] {\n  list-style-type: \"\\002A\";\n  margin-left: 8px;\n  color: #888 !important;\n}\n.availability-link[data-v-6b9a45b8] {\n  color: #2e86ab;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b9a45b8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/availability/result/inquiry/ResultTransfer.vue
// module id = 825
// module chunks = 13